import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store';
import { translateCurrentShellMessage } from '@/features/language/useI18n';

/**
 * ProtectedRoute component
 * 
 * Guards routes that require authentication.
 * Redirects to login page if user is not authenticated.
 */
export const ProtectedRoute: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);
  const login = useAuthStore((state) => state.login);
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // Automatically trigger login if not authenticated
      // Alternatively, we could redirect to a login page
      // login();
    }
  }, [isLoading, isAuthenticated, login]);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-card">
          <div className="shell-spinner" />
          <p>{translateCurrentShellMessage('Checking authentication')}</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page, preserving the intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
